// CANONICAL COPY (GH #7115). src/constants/obligations/obl-malware-protection.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-malware-protection',
  title: 'Verify malware protection measures',
  description:
    'Confirm that anti-malware software is deployed, configured for automatic updates, and centrally managed. Auto-satisfied when the Microsoft Defender for Endpoint feed has been synced within 90 days — an active Defender sync is direct evidence that Defender AV is deployed and centrally managed. Falls back to a published malware protection policy for tenants not using Defender.',
  category: 'technical',
  scfIds: ['SCF-OPS-003'],
  cadence: { frequency: '3m', anchor: 'domain' },
  strategy: 'any',
  fulfilmentCriteria: [
    // Tier 1: Active Defender sync proves Defender AV is deployed and centrally managed
    // (CIS 10.1, 10.2, 10.6, 10.7 — deploy, auto-update signatures, centrally manage,
    // behaviour-based detection).
    {
      type: 'defender-feed-fresh',
      maxAgeDays: 90,
      description:
        'Microsoft Defender for Endpoint feed has been synced within the last 90 days — confirms Defender AV is deployed and actively protecting endpoints',
    },
    // Tier 2: Manual path for tenants not using Defender.
    { type: 'document-published', description: 'Malware protection policy is published' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
